module.exports = __webpack_public_path__ + "static/media/profile__image.6192d7b5.svg";